import { FC } from "react";
import { ShopifyGeoSpatialDashboard } from "../components";
import "./ShopifyDashboard.scss";

const ShopifyDashboard: FC = () => {
  return (
    <div className="shopify-dashboard-with-data">
      <ShopifyGeoSpatialDashboard />
    </div>
  );
};

export default ShopifyDashboard;
